"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindCoreToAngularJs = exports.CoreModule = void 0;
const common_1 = require("@angular/common");
const ajs_upgraded_providers_1 = require("./services/upgraded-providers/ajs-upgraded-providers");
const core_1 = require("@angular/material/core");
const datepicker_1 = require("@angular/material/datepicker");
const a18_accordion_component_1 = require("./controls/a18-accordion/a18-accordion.component");
const a18_date_box_component_1 = require("./controls/a18-date-box/a18-date-box.component");
const a18_list_component_1 = require("./controls/a18-list/a18-list.component");
const a18_menu_component_1 = require("./controls/a18-menu/a18-menu.component");
const a18_select_box_component_1 = require("./controls/a18-select-box/a18-select-box.component");
const a18_scheduler_component_1 = require("./controls/a18-scheduler/a18-scheduler.component");
const static_1 = require("@angular/upgrade/static");
const form_field_1 = require("@angular/material/form-field");
const input_1 = require("@angular/material/input");
const language_settings_1 = require("./settings/language.settings");
const material_moment_adapter_1 = require("@angular/material-moment-adapter");
const i0 = __importStar(require("@angular/core"));
class CoreModule {
}
exports.CoreModule = CoreModule;
CoreModule.ɵfac = function CoreModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CoreModule)(); };
CoreModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CoreModule });
CoreModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        ajs_upgraded_providers_1.rootScopeProvider,
        ajs_upgraded_providers_1.smartServiceDeliveryProvider,
        // angular material
        //  datepicker
        { provide: core_1.MAT_DATE_LOCALE, useValue: language_settings_1.SUPPORTED_LANGUAGES.en },
        (0, material_moment_adapter_1.provideMomentDateAdapter)(),
        datepicker_1.MatDatepickerModule,
        core_1.MatNativeDateModule,
    ], imports: [common_1.CommonModule,
        datepicker_1.MatDatepickerModule,
        core_1.MatNativeDateModule,
        form_field_1.MatFormFieldModule,
        input_1.MatInputModule] });
function bindCoreToAngularJs(angular) {
    angular.directive('a18Accordion', (0, static_1.downgradeComponent)({ component: a18_accordion_component_1.A18AccordionComponent }));
    angular.directive('a18DateBox', (0, static_1.downgradeComponent)({ component: a18_date_box_component_1.A18DateBoxComponent }));
    angular.directive('a18List', (0, static_1.downgradeComponent)({ component: a18_list_component_1.A18ListComponent }));
    angular.directive('a18Menu', (0, static_1.downgradeComponent)({ component: a18_menu_component_1.A18MenuComponent }));
    angular.directive('a18Scheduler', (0, static_1.downgradeComponent)({ component: a18_scheduler_component_1.A18SchedulerComponent }));
    angular.directive('a18SelectBox', (0, static_1.downgradeComponent)({ component: a18_select_box_component_1.A18SelectBoxComponent }));
}
exports.bindCoreToAngularJs = bindCoreToAngularJs;
